if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form")) {
          this.form = this.querySelector("form");
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          this.querySelector("button[type=submit]").addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }

        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      canSubmitCurrentVariant() {
        if (typeof window.canAddVariantToCart === "function") {
          return window.canAddVariantToCart(this);
        }

        const variantInput =
          this.form?.querySelector('[name="id"]') ||
          this.querySelector('[name="id"]');

        return (
          !!variantInput?.value &&
          !variantInput.disabled &&
          !this.submitButton?.hasAttribute("disabled") &&
          this.submitButton?.getAttribute("aria-disabled") !== "true"
        );
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.canSubmitCurrentVariant()) return;

        const baseWarranty = window.MagstorBaseWarranty?.forForm(this);
        if (baseWarranty?.busy || baseWarranty?.blocked) return;
        let warrantyFlow = null;
        if (baseWarranty) {
          baseWarranty.busy = true;
          baseWarranty.render();
          try {
            warrantyFlow = await baseWarranty.prepare(this);
          } catch (error) {
            baseWarranty.busy = false;
            baseWarranty.render();
            baseWarranty.message(error.message);
            this.handleErrorMessage(error.message);
            return;
          }
        }
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        //For product card
        const selectedOption = this.closest(".card")?.querySelector(
          ".js-cart-option input:checked"
        );
        if (selectedOption) {
          selectedOption.nextElementSibling.classList.add("loading");
          selectedOption.nextElementSibling
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");

          this.closest(".card--product")
            .querySelectorAll(".js-cart-option input")
            .forEach((input) => {
              if (input != selectedOption) {
                input.classList.add("disabled-loading");
              }
            });
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = warrantyFlow?.data || new FormData(this.form);
        if (!this.form) {
          formData.append("id", this.querySelector("[name=id]").value);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = warrantyFlow ? baseWarranty.payload(formData, warrantyFlow.checked, warrantyFlow.quantity) : formData;

        return fetch(`${this.addUrlHandler(routes.cart_add_url)}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (baseWarranty && response.status) baseWarranty.uncertain();
            if (warrantyFlow?.checked && !response.status) {
              const driveItem = response.items?.find(item => String(item.variant_id || item.id) === "48057961054373");
              const warrantyItem = response.items?.find(item => String(item.variant_id || item.id) === "48072074002597");
              if (!driveItem || !warrantyItem) {
                baseWarranty.uncertain();
                throw new Error("Incomplete cart response. Review your cart.");
              }
              response.id = driveItem.id;
            }
            const parentProductCard = this.closest(".card--product");
            if (parentProductCard) {
              [".card__error", ".card__error--no-options"].forEach(
                (selector) => {
                  const el = parentProductCard.querySelector(selector);
                  if (el) el.innerText = "";
                }
              );
            }

            if (response.status) {
              // dispatch cart:error
              document.dispatchEvent(
                new CustomEvent("cart:error", {
                  detail: {
                    source: this.dataset.source,
                    productVariantId: formData.get("id"),
                    errors: response.description,
                    message: response.message,
                  },
                })
              );
              // dispatch cart:error

              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              //For product card
              if (parentProductCard) {
                //for color
                //this.submitButton.setAttribute("aria-disabled", true);
                //this.submitButton.setAttribute("disabled", "");
                //this.submitButton.setAttribute("title", window.variantStrings.soldOut );

                //for other option
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("aria-disabled", true);
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("disabled", "");
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("title", window.variantStrings.soldOut);

                const hasOptionsModal =
                  parentProductCard.querySelector(".js-cart-option");
                const cardError =
                  parentProductCard.querySelector(".card__error");
                const cardErrorNoOptions = parentProductCard.querySelector(
                  ".card__error--no-options"
                );
                if (hasOptionsModal && cardError) {
                  cardError.innerText = response.message;
                }

                if (!hasOptionsModal && cardErrorNoOptions) {
                  cardErrorNoOptions.innerText = response.message;
                  cardErrorNoOptions.classList.add("active");
                  setTimeout(() => {
                    cardErrorNoOptions.classList.remove("active");
                  }, 5000);
                }

                this.error = true;
                return;
              }

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // dispatch variant:add
            document.dispatchEvent(
              new CustomEvent("variant:add", {
                detail: {
                  variant: {
                    id: formData.get("id"),
                  },
                  quantity: Number(formData.get("quantity") || 1),
                  formElement: this.form,
                  sectionId: this.dataset.source,
                },
              })
            );
            // dispatch variant:add

            fetch(`${routes.cart_url}.js`)
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);

                // dispatch cart:change for the entire basket
                document.dispatchEvent(
                  new CustomEvent("cart:change", {
                    detail: {
                      cart: parsedState,
                      sectionId: this.dataset.source,
                    },
                  })
                );
                // dispatch cart:change for the entire basket
              })
              .catch((error) => {
                console.error("Error fetching cart state:", error);
              });

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (baseWarranty) {
              baseWarranty.uncertain();
              this.handleErrorMessage("Could not confirm the cart update. Review your cart before trying again.");
            }
          })
          .finally(() => {
            if (baseWarranty) {
              baseWarranty.busy = false;
              baseWarranty.render();
            }
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            //For product card
            if (this.closest(".card--product")) {
              this.submitButton.removeAttribute("aria-disabled");
            }
            if (selectedOption) {
              selectedOption.nextElementSibling.classList.remove("loading");
              selectedOption.nextElementSibling
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");

              if (!this.error) {
                selectedOption
                  .closest(".js-cart-option")
                  .classList.remove("active");
                const quickAddBtn = selectedOption
                  .closest(".card--product")
                  .querySelector(".card__link--add-to-cart_show");
                if (quickAddBtn) quickAddBtn.style.opacity = 1;
                const quickViewBtn = selectedOption
                  .closest(".card--product")
                  .querySelector(".card__quick-view_mobile");
                if (quickViewBtn) quickViewBtn.style.opacity = 1;
              }

              this.closest(".card--product")
                .querySelectorAll(".js-cart-option input")
                .forEach((input) => {
                  input.classList.remove("disabled-loading");
                  input.checked = false;
                });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      addUrlHandler(url) {
        if (url === "/cart/add") {
          return "/cart/add.js";
        }

        return url;
      }
    }
  );
}

(() => {
  if (window.MagstorBaseWarranty) return;
  const drive = '48057961054373';
  const warranty = '48072074002597';
  const controller = {
    busy: false,
    blocked: false,
    root: null,
    price: null,
    available: false,
    forms() {
      return Array.from(document.querySelectorAll('product-form')).filter(el =>
        el.form && !el.closest('.card, quick-add-modal') &&
        String(el.form.querySelector('[name="id"]')?.value) === drive
      );
    },
    forForm(el) {
      return this.root && this.forms().includes(el) ? this : null;
    },
    main() {
      return this.forms().find(el => !el.closest('.mini-card'));
    },
    quantity() {
      return Number(this.main()?.form.querySelector('[name="quantity"]')?.value || 1);
    },
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.currency || 'USD'
      }).format(cents / 100);
    },
    message(text) {
      this.root.querySelector('[data-warranty-status]').textContent = text;
    },
    render() {
      if (!this.root) return;
      const input = this.root.querySelector('[data-warranty-checkbox]');
      input.disabled = (!this.available && !input.checked) || this.busy || this.blocked;
      if (this.price !== null) {
        this.root.querySelector('[data-warranty-unit]').textContent = this.money(this.price);
        this.root.querySelector('[data-warranty-increment]').textContent = this.money(this.price);
      }
      const quantity = this.quantity();
      const valid = Number.isSafeInteger(quantity) && quantity > 0;
      const text = input.checked && this.price !== null && valid
        ? `${quantity} warranty upgrade${quantity === 1 ? '' : 's'} · Adds ${this.money(this.price * quantity)} to the drive total. Use Add to Cart to include the upgrade.`
        : 'Optional and unchecked by default. Select to add one warranty upgrade per drive using Add to Cart.';
      this.root.querySelector('[data-warranty-total]').textContent = text;
      this.forms().forEach(el => {
        el.querySelectorAll('.product-form__checkout, .shopify-payment-button').forEach(button => {
          if (input.checked) {
            if (!button.hasAttribute('data-base-warranty-hidden')) {
              button.dataset.baseWarrantyHidden = button.hidden ? 'true' : 'false';
            }
            button.hidden = true;
          } else if (button.hasAttribute('data-base-warranty-hidden')) {
            button.hidden = button.dataset.baseWarrantyHidden === 'true';
            delete button.dataset.baseWarrantyHidden;
          }
        });
      });
    },
    async refresh() {
      const url = new URL(this.root.dataset.warrantyUrl, window.location.origin);
      if (url.origin !== window.location.origin) throw new Error('Invalid warranty URL.');
      const response = await fetch(url.pathname + '.js', {
        credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(10000)
      });
      if (!response.ok) throw new Error('Unable to check warranty availability.');
      const product = await response.json();
      const variant = product.variants?.find(v => String(v.id) === warranty && v.sku === 'BASE-3YR-WAR');
      if (!variant || !Number.isSafeInteger(variant.price) || variant.price < 0) {
        throw new Error('Unable to confirm the warranty option.');
      }
      this.currency = window.Shopify?.currency?.active || 'USD';
      this.price = variant.price;
      this.available = variant.available === true;
      this.render();
      return variant;
    },
    async prepare(el) {
      const checked = this.root.querySelector('[data-warranty-checkbox]').checked;
      const quantity = this.quantity();
      if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Choose a valid drive quantity.');
      if (checked) {
        const displayedPrice = this.price;
        await this.refresh();
        if (!this.available) throw new Error('The warranty upgrade is currently unavailable. Uncheck it to add the drive alone.');
        if (this.price !== displayedPrice) throw new Error('The warranty price changed. Review the updated extra cost, then select Add to Cart again.');
      }
      const form = this.main()?.form;
      if (!form || !form.reportValidity()) throw new Error('Please complete the drive options above.');
      const data = new FormData(el.form);
      if (el !== this.main()) {
        for (const key of Array.from(data.keys())) {
          if (key === 'selling_plan' || key.startsWith('properties[')) data.delete(key);
        }
        for (const [key, value] of new FormData(form)) {
          if (key === 'selling_plan' || key.startsWith('properties[')) data.append(key, value);
        }
      }
      data.set('quantity', String(quantity));
      this.message('');
      return { data, checked, quantity };
    },
    payload(data, checked, quantity) {
      if (!checked) return data;
      const result = new FormData();
      for (const [key, value] of data) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
          result.append(`items[0][${key}]`, value);
        } else if (key.startsWith('properties[')) {
          result.append(`items[0][properties]${key.slice(10)}`, value);
        } else result.append(key, value);
      }
      result.set('items[1][id]', warranty);
      result.set('items[1][quantity]', String(quantity));
      return result;
    },
    uncertain() {
      this.blocked = true;
      this.message('We could not confirm the complete cart update. Review your cart before reloading this page and trying again. No automatic retry was sent.');
      this.render();
    },
    init() {
      if (!window.location.pathname.endsWith('/magstor-lto-8-12tb-base-thunderbolt-usb4-desktop-tape-drive')) return;
      this.root = document.querySelector('#trb5-l8-base-description [data-base-warranty]');
      if (!this.root || !this.main()) return;
      this.root.querySelector('[data-warranty-checkbox]').checked = false;
      this.root.querySelector('[data-warranty-checkbox]').addEventListener('change', () => this.render());
      const main = this.main();
      main.form.addEventListener('input', () => this.render());
      main.form.addEventListener('change', () => this.render());
      new MutationObserver(() => this.render()).observe(main, { childList: true, subtree: true });
      this.refresh().then(() => this.message(this.available ? '' : 'The warranty upgrade is currently unavailable. You can still add the drive alone.'))
        .catch(() => this.message('The warranty option could not be loaded. You can add the drive alone or view the warranty details.'));
    }
  };
  window.MagstorBaseWarranty = controller;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => controller.init(), { once: true });
  else controller.init();
})();
